import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';

const root = ReactDOM.createRoot(document.getElementById('visidea-vs-root'));
const container = document.getElementById('visidea-vs-root');
root.render(
  <I18nextProvider i18n={i18n}>
    <App website={container.getAttribute('website')} public_token={container.getAttribute('public_token')} user_id={container.getAttribute('user_id')} />
  </I18nextProvider>
);

/*
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <App website={container.getAttribute('website')} public_token={container.getAttribute('public_token')} />
    </I18nextProvider>
  </React.StrictMode>
*/
